// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"21b3ffed3e6b326c","9651":"62a44ae3652d798e"}[chunkId] + ".js";
};